<template>
  <div>
    <div id="specialsMultislider6040" class="carousel slide" data-ride="carousel" :data-brand="getBrand">
      <div class="carousel-inner" role="listbox">
        
        <!-- Slide -->
        <div class="item active">
          <div class="slide-content">
            <div class="slide-content__img" :style="{backgroundImage: bgImage1}"></div>
            <div class="slide-content__offer">
              <h3 class="slide-offer__title weight-light">2.9% APR on All New {{getBrandForSlideContent}}Models</h3>
              <p class="slide-offer__txt">Available for up to 36 months</p>
              <a href="#" class="btn btn-default slide-offer__btn btn-branded">Shop Now</a>
              <a href="#slider-disclaimers" class="slide-offer__disclaimer" data-toggle="modal" data-target="#slider6040DisclaimerModal" data-has-disclaimer="true">
                <p>Terms & Conditions</p>
              </a>
              <div class="hidden disclaimer-content">*36-months 2.9% APR - Offers for well-qualified buyers with approved credit. Applies only to dealer in-stock units. May not be combined with certain other offers. Excludes tax, tags, registration fee, title and $699 dealer administrative charge. See dealer for details.</div>
            </div>
          </div>
        </div>
        <!-- Slide -->
        <div class="item">
          <div class="slide-content">
            <div class="slide-content__img" :style="{backgroundImage: bgImage2}"></div>
            <div class="slide-content__offer">
              <h3 class="slide-offer__title weight-light">Time for an oil change?</h3>
              <p class="slide-offer__txt">Schedule an appointment with us today.</p>
              <a href="#" class="btn btn-default slide-offer__btn btn-branded">Schedule Service</a>
              <a href="#slider-disclaimers" class="slide-offer__disclaimer" data-toggle="modal" data-target="#slider6040DisclaimerModal" data-has-disclaimer="false">
                <p>Terms & Conditions</p>
              </a>
              <div class="hidden disclaimer-content">Disclaimer...</div>
            </div>
          </div>
        </div>

      </div>
      <a class="left carousel-control" href="#specialsMultislider6040" role="button" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#specialsMultislider6040" role="button" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>

    <div class="modal fade" id="slider6040DisclaimerModal" tabindex="-1" role="dialog" aria-labelledby="slider6040DisclaimerModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <!-- Dynamically Populate content here -->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props: ['images'],
    data() {
      return {
        brand: this.$store.state.chosenBrand
      }
    },
    computed: {
      getBrand () {
        if (this.brand.toLowerCase() === 'none') {
          return 'Default';
        } else {
          return this.brand.substr(0,1).toUpperCase() + this.brand.substr(1);
        }
      }, 

      getBrandForSlideContent () {
        return this.formatBrandForSlideContent();
      }, 

      bgImage1 () {
        return 'url(' + this.images.lifestyleImages.sedanImage + ')';
      }, 

      bgImage2 () {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      }
    }, 

    mounted () {
      this.init();
    }, 

    methods: {
      init () {
        this.populateDisclaimerModal();
        $('#specialsMultislider6040').carousel({
          interval: 5000
        });
      }, 

      returnBrand () {
        if (this.brand.toLowerCase() === 'none') {
          return 'Default';
        } else {
          return this.brand.substr(0,1).toUpperCase() + this.brand.substr(1);
        }
      }, 

      formatBrandForSlideContent () {
        const brand = this.returnBrand();
        if (brand === 'Default') {
          return ' ';
        } else {
          return ' ' + brand + ' ';
        }
      }, 

      populateDisclaimerModal () {
        $('#specialsMultislider6040 .slide-offer__disclaimer').click(function(){
          const disclaimerContent = $(this).parent().find('.disclaimer-content').html();
          $('#slider6040DisclaimerModal .modal-body').empty().append(disclaimerContent);
        })
      }
    }
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>

  #preview:has(#specialsMultislider6040) {
      margin-left: -9px;
      margin-right: -9px;
  }
  
  /* Utility Classes */
  .btn-branded {
    display: inline-block;
    background-color: transparent;
    color: #ffffff;
    border: solid 1px #ffffff;
    border-radius: 0;
    padding: 12px 20px;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    font-size: 14px;
    line-height: 1.428571429;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .btn-branded:hover, 
  .btn-branded:active, 
  .btn-branded:focus {
    background-color: #ffffff;
    border-color: var(--primary-dark);
    color: var(--primary-dark);
  }

  .btn-branded--fill {
    background-color: var(--primary-dark);
    border-color: var(--primary-dark);
    color: #ffffff;
  }

  .btn-branded--fill:hover, 
  .btn-branded--fill:active, 
  .btn-branded--fill:focus {
    background-color: #ffffff;
    border-color: var(--primary-dark);
    color: var(--primary-dark);
  }

  /* Brand-Specific Utility Styles */
  
  #specialsMultislider6040[data-brand="Toyota"] .btn-branded {
    border-radius: 50px;
    padding: 10px 20px 12px 20px;
  }

  #specialsMultislider6040[data-brand="Infiniti"] .slide-content__offer {
    background-color: var(--primary-color, #020B24);
  }
  #specialsMultislider6040[data-brand="Infiniti"] .slide-offer__title,
  #specialsMultislider6040[data-brand="Infiniti"] .slide-offer__txt,
  #specialsMultislider6040[data-brand="Infiniti"] .btn-branded,
  #specialsMultislider6040[data-brand="Infiniti"] .slide-offer__disclaimer {
    font-family: Infiniti-Light, 'Infiniti-Light', Arial, sans-serif;
  }
  #specialsMultislider6040[data-brand="Infiniti"] .btn-branded {
    border-radius: 50px;
    border: 3px solid var(--primary-light, #ffffff)
  }
  
  /* 6040 Slider Styles */

  #specialsMultislider6040 .carousel-inner .item {
    width: 100%;
  }
  #specialsMultislider6040 .slide-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 300px;
    height: 45vh;
    max-height: 450px;
  }
  #specialsMultislider6040 .slide-content > * {
    height: 100%;
  }
  #specialsMultislider6040 .slide-content__img {
    width: 60%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  #specialsMultislider6040 .slide-content__offer {
    width: 40%;
    height: 100%;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: var(--primary-dark);
    color: #ffffff;
    padding: 15px 7% 15px 3%;
  }
  .slide-offer__title {
    margin: 0 0 25px 0;
    text-shadow: 0 0 #ffffff;
    font-size: 28px;
  }
  .slide-offer__txt {
    font-size: 14px;
  }
  .slide-offer__btn {
    margin: 20px 0 40px 0;
  }
  .slide-offer__disclaimer {
    text-decoration: none;
    font-size: 10px;
    color: #ffffff;
    border-bottom: solid 1px #ffffff;
    padding-bottom: 2px;
    opacity: 0.7;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .slide-offer__disclaimer:hover, 
  .slide-offer__disclaimer:active, 
  .slide-offer__disclaimer:focus {
    text-decoration: none;
    color: #ffffff;
    opacity: 1;
  }
  #specialsMultislider6040 .slide-offer__disclaimer {
    display: none;
  }
  #specialsMultislider6040 .slide-offer__disclaimer[data-has-disclaimer="true"], 
  #specialsMultislider6040 .slide-offer__disclaimer[data-has-disclaimer="True"] {
    display: block;
  }
  .slide-offer__disclaimer p {
    margin-bottom: 0;
  }
  #specialsMultislider6040 .carousel-control {
    opacity: 0.7;
    width: 7.5%;
  }
  #specialsMultislider6040 .carousel-control:hover, 
  #specialsMultislider6040 .carousel-control:active, 
  #specialsMultislider6040 .carousel-control:focus {
    opacity: 1;
  }
  #specialsMultislider6040 .carousel-control .glyphicon-chevron-left {
    transform: translateX(-25%);
  }
  #specialsMultislider6040 .carousel-control .glyphicon-chevron-right {
    transform: translateX(25%);
  }

  #specialsMultislider6040 .carousel-control .glyphicon::before {
    content: '';
  }
  #specialsMultislider6040 .carousel-control .glyphicon {
    background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/309/655/original/toyota-arrow-right-white.png?1669999978);
    background-position: center;
    background-size: 30%;
    background-repeat: no-repeat;
    border: solid 2px #ffffff;
    border-radius: 100%;
    width: 40px;
    height: 40px;
  }
  #specialsMultislider6040 .carousel-control .glyphicon-chevron-left {
    transform: translateX(-25%) rotate(180deg);
  }

  @media (min-height: 789px) {
    #specialsMultislider6040 .slide-content {
      height: 50vh;
    }
  }

  @media (max-width: 767px) {
    #specialsMultislider6040 .slide-content {
      flex-direction: column;
      min-height: 350px;
      height: 57vh;
    }

    #specialsMultislider6040 .slide-content__img {
      width: 100%;
      height: 40%;
    }

    #specialsMultislider6040 .slide-content__offer {
      width: 100%;
      height: 60%;
    }

    .slide-offer__title {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .slide-offer__txt {
      font-size: 12px;
    }

    .slide-offer__btn {
      margin: 10px 0 20px 0;
    }

    #specialsMultislider6040 .carousel-control {
      width: 13%;
      bottom: unset;
      top: 20%;
      opacity: 1;
    }

    #specialsMultislider6040.carousel .carousel-control .glyphicon {
      border-color: transparent;
    }

  }

  /* Brand-Specific Component Styles */
  #specialsMultislider6040:not([data-brand="Toyota"]) .carousel-control .glyphicon {
    border: none;
  }

</style>